import { FeatureFlagKeys } from "@sg-protect/federation-runtime";
import { useFeatureFlag } from "@sg-protect/federation-runtime/squide";
import { RegionGate, useIsOnboardingRoute } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";
import { usePaths } from "../../paths.ts";

export const ProtectRegionGate = ({ children }: PropsWithChildren) => {
    const isOnboardingRoute = useIsOnboardingRoute();
    const paths = usePaths();
    const isInlineDataRegionSelectionReleased = useFeatureFlag(
        FeatureFlagKeys.InlineDataRegionSelectionReleased,
        false
    );

    return (
        <RegionGate
            redirectTo={isInlineDataRegionSelectionReleased ? paths.setupReviewPermissions : paths.setupDataRegion}
            shouldSkip={isOnboardingRoute}
        >
            {children}
        </RegionGate>
    );
};
